import React from 'react';
import { Badge } from 'react-bootstrap';

import ExcelFileStatus from '../../../../app/support/ExcelFileStatus';

const RetencionesMasivasFilesRenderStatus = ({ item }) => {
  let variant = 'light';

  const status = ExcelFileStatus.search(item.status);

  if (status.isProcessed()) {
    variant = 'success';
  } else if (status.isError()) {
    variant = 'danger';
  } else if (!status.isPending()) {
    variant = 'info';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

export default RetencionesMasivasFilesRenderStatus;
